










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SurveyModel } from "survey-core";
import { QuestionRowModel } from "survey-core";
import { BaseVue } from "./base";
import { Base } from "survey-core";

@Component
export class SurveyRowElement extends BaseVue {
  @Prop() element: any;
  @Prop() row: QuestionRowModel;
  @Prop() css: any;
  @Prop() survey: SurveyModel;

  protected getModel(): Base {
    return this.element;
  }
}
Vue.component("survey-row-element", SurveyRowElement);
export default SurveyRowElement;
